import "./DryingEndpoint.module.css";
import Header from "@/reusable_sections/Header";
import DryingHero from "./sections/DryingHero";
import Challenges from "./sections/Challenges";
import Process from "./sections/Process";
import Solutions from "./sections/Solutions";
import Roadmap from "./sections/Roadmap";
import ProcessServices from "./sections/ProcessServices";
import DryingCta from "./sections/DryingCta";
import Footer from "@/reusable_sections/Footer";
export default function DryingEndpointPage() {
  return <div>
      <Header />
      <DryingHero />
      <Challenges />
      <Process />
      <Solutions />
      <Roadmap />
      <ProcessServices />
      <DryingCta />
      <Footer />
    </div>;
}